import moment from 'moment';
import { numberUnmask } from 'utils/masks';

export default {
  accountHolderName: [{
    rule: 'required',
    isValid: input => !!input || 'The input field is required',
  }],
  accountNumber: [
    {
      rule: 'required',
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }

        return /^(\d)\1+$/.test(input) ? 'Account Number is not valid' : true;
      },
    },
  ],
  bankName: [{
    rule: 'required',
    isValid: input => !!input || 'The input field is required',
  }],
  routingNumber: [
    {
      rule: 'required',
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }

        if (`${input}`.replace('_', '').length < 9) {
          return 'Routing Number is not valid';
        }

        return /^(\d)\1+$/.test(input) ? 'Routing Number is not valid' : true;
      },
    },
  ],
  dateOfEnrollment: [{
    rule: 'required',
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }

      if (numberUnmask(input).length < 8) {
        return 'Date of Enrollment is not valid';
      }

      if (!moment(input, 'MM/DD/YYYY').isValid()) {
        return 'Date of Enrollment is not valid';
      }
      return true;
    },
  }],
  monthlyDraftDate: [{
    rule: 'required',
    isValid: input => !!input || 'The input field is required',
  }],
  totalNumberOfSuccessfulPayments: [{
    rule: 'required',
    isValid: input => !!input || 'The input field is required',
  }],

  settlementDate: [{
    isValid: (input) => {
      if (input) {
        if (numberUnmask(input).length < 8) {
          return 'Settlement date is not valid';
        }

        if (!moment(input, 'MM/DD/YYYY').isValid()) {
          return 'Settlement date is not valid';
        }
      }
      return true;
    },
  }],
  signature: [{
    rule: 'required',
    isValid: (input) => {
      if (!input || input.trim().length === 0) {
        return 'The input field is required';
      }

      return true;
    },
  }],
};



// WEBPACK FOOTER //
// ./src/containers/pages/DscComponent/schema.js